import React from 'react';

/**
 * Loading placeholders shaped like the real pages, so content swaps in
 * without the layout jumping. Purely decorative: hidden from assistive tech,
 * the wrapper announces "loading" once.
 */

const Bone = ({ className = '', style }) => <span className={`ui-skeleton ${className}`} style={style} />;

// Anime / manga details: hero with cover, chips, title, meta and actions, then the description.
export const DetailSkeleton = () => (
    <div className="detail-skeleton" role="status" aria-label="Загружаем">
        <div className="detail-skeleton__hero">
            <Bone className="detail-skeleton__cover" />
            <div className="detail-skeleton__info">
                <div className="detail-skeleton__chips">
                    <Bone style={{ width: 48 }} />
                    <Bone style={{ width: 132 }} />
                    <Bone style={{ width: 110 }} />
                </div>
                <Bone className="detail-skeleton__title" />
                <Bone className="detail-skeleton__line" style={{ width: '42%' }} />
                <Bone className="detail-skeleton__line" style={{ width: '56%' }} />
                <div className="detail-skeleton__actions">
                    <Bone className="detail-skeleton__button" />
                    <Bone className="detail-skeleton__icon" />
                </div>
            </div>
        </div>
        <div className="detail-skeleton__body">
            <Bone className="detail-skeleton__heading" />
            <Bone className="detail-skeleton__line" style={{ width: '100%' }} />
            <Bone className="detail-skeleton__line" style={{ width: '94%' }} />
            <Bone className="detail-skeleton__line" style={{ width: '72%' }} />
        </div>
    </div>
);

// Profile: avatar, nickname, meta pills and the first cards of the two columns.
export const ProfileSkeleton = () => (
    <div className="profile-skeleton" role="status" aria-label="Загружаем профиль">
        <div className="profile-skeleton__hero">
            <Bone className="profile-skeleton__avatar" />
            <div className="profile-skeleton__info">
                <Bone className="profile-skeleton__name" />
                <div className="detail-skeleton__chips">
                    <Bone style={{ width: 92 }} />
                    <Bone style={{ width: 168 }} />
                    <Bone style={{ width: 84 }} />
                </div>
                <Bone className="detail-skeleton__line" style={{ width: 220 }} />
                <div className="detail-skeleton__actions">
                    <Bone className="detail-skeleton__button" />
                    <Bone className="detail-skeleton__icon" />
                </div>
            </div>
        </div>
        <div className="profile-skeleton__grid">
            <Bone className="profile-skeleton__card profile-skeleton__card--main" />
            <Bone className="profile-skeleton__card" />
        </div>
    </div>
);
